import service from '@/utils/server';

const modName = '/assess/trackWhKpi/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//批量删除
export const deleteBatch = data => {
  return service({
    url: modName + 'deleteBatch',
    method: 'post',
    data
  });
};
//导出
export const exportData = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};
//导入
export const upload = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadWhKpi',
    method: 'post',
    data
  });
};
//模板下载
export const downLoadTemplate = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/assess/whKeyIndicator/api/index.js